
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/react-19-update",
      function () {
        return require("private-next-pages/blog/react-19-update.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/react-19-update"])
      });
    }
  